import { IInfoIniciativasWS } from "../interfaces/Workspace";
import { getQueryParameter } from "../util/helpers";
import { get } from "./fetch";

export const indexIniciativasWS = async (queryParams?:{
    contraparte?:number, 
    clave?:number,
    text?:string,
    is_archivo?:number,
}): Promise<IInfoIniciativasWS[]> => {
    let queryString = getQueryParameter(queryParams);
    //Stored Procedure: WS_GET_Lista_Programas_Web OP:1
    var result:IInfoIniciativasWS[] = await get(`/api/informacion-proyectos-ws${queryString}`);
    return result;
}